export default __webpack_public_path__ + "static/media/developer_Image.a796d463.jpg";